import { render, staticRenderFns } from "./GenerateWaitingList.vue?vue&type=template&id=6eb6201c"
import script from "./GenerateWaitingList.vue?vue&type=script&lang=js"
export * from "./GenerateWaitingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports